import validate from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_better-sqlite3@11.9.1_db0@0.3.1_b_36f36f936940ff8287887fd30ab8bebd/node_modules/nuxt/dist/pages/runtime/validate.js";
import is_45desktop_45global from "/opt/render/project/src/libs/nuxt-forgd-layer-core/middleware/is-desktop.global.ts";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_better-sqlite3@11.9.1_db0@0.3.1_b_36f36f936940ff8287887fd30ab8bebd/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  is_45desktop_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "launch-designer-state": () => import("/opt/render/project/src/apps/ui/layers/liquidity-launch-designer/middleware/launch-designer-state.ts"),
  auth: () => import("/opt/render/project/src/libs/nuxt-forgd-layer-core/layers/auth/middleware/auth.ts"),
  guest: () => import("/opt/render/project/src/libs/nuxt-forgd-layer-core/layers/auth/middleware/guest.ts")
}